import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  Form,
} from "reactstrap";
import { Link } from "react-router-dom";
import editEventImg from "../../../assets/images/Digital Marketing/editEventImg.jpg";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { useNavigate } from "react-router-dom";

// css
import "../../../assets/css/Settings/Setting.css";

// commom
import Pagination from "components/Common/Pagination";
import Swal from "sweetalert2";
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import { BiddingSourceColumns } from "utils/columns/Marketing/TenderCols";

function TableContainer({ columns, data, fetchData }) {
  const [modal_center, setmodal_center] = useState(false);
  const [fixedContent, setFixedContent] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [addName, setAddName] = useState("");
  const [addUrl, setAddUrl] = useState("");
  const [isLoading, setLoading] = useState(false);
  const toggleLoading = (loading) => setLoading(loading);

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  // Center Modal
  function tog_center() {
    setAddModal(true);
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  const handleAddSite = async (e) => {
    e.preventDefault();
    try {
      const response = await FetchNodePostData(
        toggleLoading,
        `biddingSource`,
        secureLocalStorage?.getItem("auth_token"),
        { name: addName, url: addUrl }
      );
      if (response.status === 200) {
        setAddModal(false);
        setAddName("");
        setAddUrl("");
        fetchData();
        Swal.fire({ icon: "success", text: "Site Added Successfully" });
      }
    } catch (err) {
      console.error("Error adding site:", err);
      Swal.fire({ icon: "error", text: "Failed to Add Site" });
    }
  };

  // Render the UI for your table
  return (
    <div>
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => {
            tog_center();
          }}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2 icon-size"></i>
          <span>Site</span>
        </button>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="">
            <button
              onClick={() => {
                tog_center();
              }}
              className="border-radius btn btn-purple"
            >
              {" "}
              <i className="fas fa-plus me-2 icon-size"></i>Add Site
            </button>
            <button
              onClick={() => navigate(-1)}
              className="border-radius btn ms-md-2 btn-red"
            >
              <i className="dripicons-cross me-2 icon-center"></i>CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${index === 1 || index === 2 ? "4" : "2"}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                  {column.isInfoIcon ? (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      className={`col-md-${
                        index === 1 || index === 2 ? "4" : "2"
                      }`}
                      key={index}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      {/* Add Department Modal */}
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center();
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Bidding Document</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false);
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form>
            <Row>
              <div className="col-2">
                <label htmlFor="">Number </label>
                <input type="number" className="form-control border-radius" />
              </div>
              <div className="col-5">
                <label htmlFor="">Site Name </label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className="form-control border-radius"
                />
              </div>
              <div className="col-5">
                <label htmlFor="">Site URL</label>
                <input
                  type="text"
                  placeholder="Enter Url"
                  className="form-control border-radius"
                />
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button className="btn btn-purple border-radius">Submit</button>
            </div>
          </Form>
        </div>
      </Modal>
      {/* ------------ */}
      <Modal isOpen={addModal} size="lg" centered>
        <div className="modal-header py-3 px-4 border-bottom-0">
          <h5 className="modal-title mt-0">Add Site</h5>
          <button
            type="button"
            onClick={() => setAddModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body p-4">
          <Form onSubmit={handleAddSite}>
            <Row>
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img src={editEventImg} alt="Site" style={{ width: "90%" }} />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 col-12">
                  <label className="form-label">Site Name</label>
                  <Input
                    type="text"
                    value={addName}
                    onChange={(e) => setAddName(e.target.value)}
                    placeholder="Enter Site Name"
                    required
                  />
                </div>
                <div className="mb-3 col-12">
                  <label className="form-label">Site URL</label>
                  <Input
                    type="text"
                    value={addUrl}
                    onChange={(e) => setAddUrl(e.target.value)}
                    placeholder="Enter URL"
                    required
                  />
                </div>
              </div>
            </Row>
            <Row>
              <Col className="col-12 text-end">
                <button type="submit" className="btn btn-purple border-radius">
                  <i className="fas fa-save me-1"></i> Submit
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  );
}

const BiddingSite = () => {
  const [modal_center, setmodal_center] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editUrl, setEditUrl] = useState("");

  const openEditModal = (site) => {
    setEditId(site.id);
    setEditName(site.name);
    setEditUrl(site.url);
    setEditModal(true);
  };

  

  const toggleLoading = (loading) => setLoading(loading);
  console.log(`starting to call the fetchData function`);

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await FetchNodePutData(
        toggleLoading,
        `biddingSource`,
        editId,
        { name: editName, url: editUrl }
      );
      if (response.status === 200) {
        setEditModal(false);
        fetchData();
        Swal.fire({ icon: "success", text: "Site Updated Successfully" });
      }
    } catch (err) {
      console.error("Error editing site:", err);
      Swal.fire({ icon: "error", text: "Failed to Update Site" });
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetchNodeData(
        toggleLoading,
        "biddingSource",
        secureLocalStorage?.getItem("auth_token")
      );
      console.log(`response: `, response);
      if (Array.isArray(response?.data)) {
        setData(response.data);
      } else {
        setData([]);
        console.error("Expected array but got:", response.data);
      }
    } catch (error) {
      console.error("Fetch Error", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (e, id) => {
      e.preventDefault();
      const response = await FetchNodeDeleteData(
        toggleLoading,
        `biddingSource`,
        id
      );
      if (response.data) {
        fetchData();
        Swal.fire({ icon: "success", text: "Document Deleted Successfully" });
      } else {
        Swal.fire({
          icon: "error",
          text: response.data?.message || "Failed to delete document",
        });
      }
    };

  // Center Modal
  function tog_center() {
    setmodal_center(!modal_center);
    removeBodyCss();
  }

  const columns = useMemo(
    () => BiddingSourceColumns(openEditModal, handleDelete),
    []
  );

  //
  return (
    <>
      <div>
        <Row className="ms-0 pe-0">
          <Col lg={12} className="p-0">
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={data}
                  fetchData={fetchData}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal isOpen={editModal} size="lg" centered>
        <div className="modal-header py-3 px-4 border-bottom-0">
          <h5 className="modal-title mt-0">Edit Site</h5>
          <button
            type="button"
            onClick={() => setEditModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body p-4">
          <Form onSubmit={handleEditSubmit}>
            <Row>
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img src={editEventImg} alt="Site" style={{ width: "90%" }} />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 col-12">
                  <label className="form-label">Site Name</label>
                  <Input
                    type="text"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    placeholder="Enter Site Name"
                    required
                  />
                </div>
                <div className="mb-3 col-12">
                  <label className="form-label">Site URL</label>
                  <Input
                    type="text"
                    value={editUrl}
                    onChange={(e) => setEditUrl(e.target.value)}
                    placeholder="Enter URL"
                    required
                  />
                </div>
              </div>
            </Row>
            <Row>
              <Col className="col-12 text-end">
                <button type="submit" className="btn btn-purple border-radius">
                  <i className="fas fa-save me-1"></i> Submit
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      {/* Edit Department Modal */}
      <Modal
        isOpen={modal_center}
        toggle={() => {
          tog_center();
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Category</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_center(false);
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form>
            <Row>
              <div className="col-2">
                <label htmlFor="">Number </label>
                <input type="number" className="form-control border-radius" />
              </div>
              <div className="col-5">
                <label htmlFor="">Site Name </label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className="form-control border-radius"
                />
              </div>
              <div className="col-5">
                <label htmlFor="">Site URL</label>
                <input
                  type="text"
                  placeholder="Enter Url"
                  className="form-control border-radius"
                />
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
            <div className="text-end">
              <button className="btn btn-purple border-radius">Submit</button>
            </div>
          </Form>
        </div>
      </Modal>
      {/* ------------ */}
    </>
  );
};

export default BiddingSite;
